import { LOCALES } from '~/constants';

export default function isLocaleSupported(locale: string) {
  return LOCALES.SUPPORTED_LOCALES.includes(locale);
}
